import React from 'react';
import { connect } from 'react-redux';
import {
  applyToTemplates as applyToTemplatesAction,
  selectMaster as selectMasterAction,
} from '../../__storeFiles__/actions';
import { RaisedButton, RadioButton, FontIcon } from 'material-ui';
import LoadingOverlay from '../../../../tc-ui/loading-overlay';
import injectCss from 'react-jss';
import styles from '../../styles';
import {
  goBack as goBackAction,
  replace as replaceAction,
} from 'react-router-redux';
import OverwriteRules from '../overwrite-rules';

const PickMasterWizard = ({
  masterList,
  callingApi,
  classes,
  applyToTemplates,
  goBack,
  replace,
  selectMaster,
  sameAsCorporatePolicyNotes,
}) => {
  const totalSelected = masterList.filter(obj => obj.checked).length;
  return (
    <div className="full-screen-page">
      <div
        className={classes.topbar}
      >
          <span>
            Pick A Corporate Policies & Notes Template
          </span>
      </div>
      <div className={classes.topbarActions}>
        <div
          key="closeBtn"
          className={classes.closeBtn}
          onClick={goBack}
        >
          <FontIcon className="tc-icon-close" style={{ fontSize: '36px', color: '#fff' }} />
        </div>
      </div>
      {
        masterList.length
        ? (
            <div className={classes.body} style={{ padding: '70px 20%' }}>
              <div className="flex-tc-stretch">
                <div style={{ padding: '16px', width: '70%' }}>
                  <div className={classes.applyStepperLabel}>
                    Step 1: Select the Corporate Policies & Notes template that you’d like to apply
                  </div>
                  {
                    masterList.map(obj => (
                      <RadioButton
                        key={obj._id}
                        checked={Boolean(obj.checked)}
                        onCheck={() => selectMaster({ id: obj._id })}
                        label={obj.templateName}
                      />
                    ))
                  }
                </div>
                <OverwriteRules
                  classes={classes}
                  style={{ width: '50%' }}
                />
              </div>
            </div>
          )
        : (
            <div
              className={classes.body}
              style={{
                padding: '70px 20%',
                textAlign: 'center',
              }}
            >
              <div style={{ fontSize: '16px', margin: '32px auto', color: 'rgba(0, 0, 0, 0.74)' }}>
                You do not have any Corporate Policies & Notes templates to apply.
              </div>
              <p style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                What is a Corporate Policies & Notes template?
              </p>
              <p style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                Corporate Policies & Notes allow you to create master policies that can be shared across multiple templates. If you ever need to update these policies or notes, all you’ll need to do is update the master, and we’ll update the associated templates.
              </p>
              <RaisedButton
                label="Create a Corporate Policies & Notes Template"
                primary
                onTouchTap={() => replace('/contracting/create-master-template')}
              />
            </div>
          )
      }
      <div className={`${classes.bottomBar} flex-center ${totalSelected ? 'is-active' : ''}`}>
        <RaisedButton
          label="Apply"
          primary
          disabled={!totalSelected || callingApi || !sameAsCorporatePolicyNotes.length}
          onTouchTap={applyToTemplates}
        />
      </div>
      <LoadingOverlay loading={callingApi} />
    </div>
  );
};

const mapStateToProps = ({
  contracting: {
    masterTemplate: { applyMasterToTemplatesReducer },
  },
}) => {
  return {
    ...applyMasterToTemplatesReducer,
  };
};

export default connect(
  mapStateToProps,
  {
    replace: replaceAction,
    applyToTemplates: applyToTemplatesAction,
    selectMaster: selectMasterAction,
    goBack: goBackAction,
  },
)(injectCss(styles)(PickMasterWizard));



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/apply-master-wizards/pick-one-master-for-one-template/wizard.jsx